(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7358],{

/***/ 48488:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sindromedeseptiembre",
      function () {
        return __webpack_require__(96795);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 23793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* reexport safe */ _useToasts__WEBPACK_IMPORTED_MODULE_0__.e; }
/* harmony export */ });
/* harmony import */ var _useToasts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57064);



/***/ }),

/***/ 96795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ sindromedeseptiembre; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./features/magnets/septiembre25/LandingSeptiembre25.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 36px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  height: min(calc(100vw * 3 / 4), 100vh);\n  background: url(",
        ") center\n    center / cover no-repeat;\n\n  @media (max-width: ",
        ") {\n    background: url(",
        ")\n      center center / cover no-repeat;\n    height: calc(100vw * 16 / 9);\n  }\n\n  .logo {\n    position: absolute;\n    top: clamp(20px, 5vw, 40px);\n    right: clamp(20px, 5vw, 40px);\n    width: clamp(100px, 25vw, 200px);\n    height: auto;\n    z-index: 3;\n  }\n\n  .folder-container {\n    position: relative;\n    display: inline-block;\n    z-index: 2;\n    width: min(60%, 600px);\n\n    @media (max-width: ",
        ") {\n      width: 90%;\n    }\n\n    .folder {\n      display: block;\n      width: 100%;\n      height: auto;\n      position: relative;\n      z-index: 1;\n    }\n\n    .tab-1,\n    .tab-2,\n    .tab-3 {\n      text-align: center;\n      z-index: 2;\n      position: absolute;\n      top: 8%;\n      transform: translate(-50%, -50%);\n      font-size: min(1vw, 0.9rem);\n      font-weight: ",
        ";\n      white-space: nowrap;\n    }\n    .tab-1 {\n      left: 20%;\n    }\n    .tab-2 {\n      left: 50%;\n    }\n    .tab-3 {\n      left: 78%;\n    }\n\n    .text {\n      max-width: 80%;\n      z-index: 2;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    .cursor {\n      z-index: 3;\n      position: absolute;\n      top: 70%;\n      left: 90%;\n      transform: translate(-50%, -50%);\n      width: 80px;\n      max-width: 8%;\n    }\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 20%;\n    background: linear-gradient(\n      to bottom,\n      rgba(247, 242, 223, 0) 0%,\n      rgba(247, 242, 223, 0.7) 50%,\n      #f7f2df 100%\n    );\n    z-index: 0;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f7f2df;\n  font-size: clamp(",
        ", 2.2vw, ",
        ");\n  line-height: clamp(24px, 3.3vw, 36px);\n  padding: 6rem clamp(20px, 8.8vw, 1000px) 6rem clamp(20px, 10vw, 1000px);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4rem;\n\n  & > * {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 4rem;\n  width: 100%;\n  background: url(",
        ") top center /\n    cover no-repeat;\n  padding: 8rem clamp(20px, 8.8vw, 1000px) 8rem clamp(20px, 10vw, 1000px);\n\n  .cowsText {\n    max-width: ",
        ";\n    background-color: #d9d9d9;\n    font-size: clamp(",
        ", 2.2vw, ",
        ");\n    line-height: clamp(24px, 3.3vw, 36px);\n    padding: clamp(20px, 5.5vw, 5rem);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: #f7f2df;\n\n  & > * {\n    max-width: ",
        ";\n    margin: 0 auto;\n  }\n\n  .featuredVideosDesc {\n    max-width: ",
        ";\n    font-size: clamp(",
        ", 2.2vw, ",
        ");\n    line-height: clamp(24px, 3.3vw, 36px);\n    padding: clamp(20px, 10%, 5rem);\n  }\n\n  .videos {\n    max-width: ",
        ";\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 3rem;\n    justify-content: center;\n    align-items: center;\n    padding: 0 clamp(20px, 10%, 5rem) 6rem clamp(20px, 10%, 5rem);\n\n    @media (min-width: 768px) and (max-width: 1100px) {\n      display: flex;\n      & > * {\n        width: 33%;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4rem;\n  width: 100%;\n  height: auto;\n  background: url(",
        ") top\n    center / cover no-repeat;\n  padding-top: 8rem;\n\n  .title {\n    width: min(",
        ", 90%);\n    font-size: clamp(",
        ", 3vw, ",
        ");\n    font-weight: ",
        ";\n    padding: 0 clamp(20px, 8.8vw, 1000px);\n  }\n  .questions {\n    width: min(",
        ", 90%);\n    font-size: clamp(",
        ", 2.2vw, ",
        ");\n    padding: 0 clamp(20px, 8.8vw, 1000px);\n  }\n\n  .surveyImage {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n    z-index: 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: #f7f2df;\n  padding: clamp(20px, 10%, 5rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  font-size: clamp(",
        ", 2.2vw, ",
        ");\n\n  & > * {\n    max-width: ",
        ";\n  }\n\n  .description {\n    margin-top: 5rem;\n    font-size: clamp(",
        ", 2.2vw, ",
        ");\n    margin-bottom: 1rem;\n  }\n\n  .form-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    width: 100%;\n  }\n\n  .label {\n    font-weight: bold;\n  }\n\n  .input-group {\n    display: flex;\n    align-items: center;\n    gap: 3rem;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .input {\n    width: 55%;\n    height: 3.5rem;\n    padding: 0.75rem 1.25rem;\n    border-radius: ",
        ";\n    border: none;\n    background-color: #acacac;\n    color: #2d2d2d;\n    outline: none;\n    flex-grow: 1;\n    font-size: clamp(",
        ", 2.2vw, ",
        ");\n    font-family: ",
        ";\n\n    &::placeholder {\n      color: #8c8c8c;\n    }\n  }\n\n  .button {\n    width: 35%;\n    height: 3.5rem;\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: ",
        ";\n    background-color: #84441c;\n    color: #f7f2df;\n    cursor: pointer;\n    outline: none;\n    white-space: nowrap;\n    font-size: clamp(",
        ", 2.2vw, ",
        ");\n    font-family: ",
        ";\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n  }\n\n  .socials {\n    margin-top: 3rem;\n    margin-bottom: 1rem;\n    font-size: clamp(",
        ", 2.2vw, ",
        ");\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n\n    .icons {\n      display: flex;\n      align-items: center;\n      gap: 1.5rem;\n      margin-top: 0.5rem;\n    }\n\n    img {\n      height: 50px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  position: relative;\n  min-height: 90vh;\n  width: 100%;\n  background: url(",
        ") top center /\n    cover no-repeat;\n\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: clamp(",
        ", 3vw, ",
        ");\n\n  .topText {\n    position: absolute;\n    top: 5%;\n    text-align: center;\n    padding-left: clamp(20px, 5vw, 100px);\n    padding-right: clamp(20px, 5vw, 100px);\n  }\n\n  .beamText {\n    position: absolute;\n    bottom: 20%;\n  }\n\n  .logo {\n    position: absolute;\n    right: clamp(12px, 3vw, 28px);\n    bottom: clamp(12px, 3vw, 28px);\n    width: clamp(100px, 25vw, 200px);\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-0"
})(_templateObject(), (0,theme/* fontFamily */.I8)("ibm"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontWeight */.Ue)("medium"));
var Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-1"
})(_templateObject1(), (0,paths/* getPublicPath */.A)("/images/septiembre25/mount.jpg"), (0,theme/* screen */.sp)("md"), (0,paths/* getPublicPath */.A)("/images/septiembre25/mount_small.png"), (0,theme/* screen */.sp)("md"), (0,theme/* fontWeight */.Ue)("bold"));
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* container */.nC)("lg"));
var Cows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-3"
})(_templateObject3(), (0,paths/* getPublicPath */.A)("/images/septiembre25/cows.png"), (0,theme/* container */.nC)("lg"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"));
var FeaturedVideos = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-4"
})(_templateObject4(), (0,theme/* container */.nC)("xl2"), (0,theme/* container */.nC)("lg"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* container */.nC)("xlMax"));
var Survey = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-5"
})(_templateObject5(), (0,paths/* getPublicPath */.A)("/images/septiembre25/hiking_b.png"), (0,theme/* container */.nC)("xlMax"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* container */.nC)("xlMax"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"));
var Subscribe = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-6"
})(_templateObject6(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* container */.nC)("lg"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* radius */.q0)("lg"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontFamily */.I8)("mono"), (0,theme/* radius */.q0)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontFamily */.I8)("mono"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"));
var UfoFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-255720e1-7"
})(_templateObject7(), (0,paths/* getPublicPath */.A)("/images/septiembre25/ufo.png"), (0,theme/* fontFamily */.I8)("mono"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("xl"));

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./features/magnets/septiembre25/Videos.tsx

function Videos_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f7f2df;\n  overflow: hidden;\n  text-align: left;\n"
    ]);
    Videos_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Videos_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: clamp(",
        ", 2.2vw, ",
        ");\n  font-weight: ",
        ";\n  color: #2d2d2d;\n  display: flex;\n  align-items: flex-end;\n  height: 4rem;\n"
    ]);
    Videos_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Videos_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n\n  padding-bottom: 177.78%; /* 16:9 Aspect Ratio */\n  background-color: #000;\n  border-radius: ",
        ";\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: none;\n    border-radius: ",
        ";\n    object-fit: fill;\n  }\n"
    ]);
    Videos_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var getYouTubeVideoId = function(url) {
    var regExp = // eslint-disable-next-line no-useless-escape
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&?]*).*/;
    var match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
};
var VideoCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ac6203-0"
})(Videos_templateObject());
var VideoTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ac6203-1"
})(Videos_templateObject1(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("black"));
var VideoEmbedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3ac6203-2"
})(Videos_templateObject2(), (0,theme/* radius */.q0)("full"), (0,theme/* radius */.q0)("lg"));
// Reusable FeaturedVideo Component
var FeaturedVideo = function(param) {
    var videoId = param.videoId;
    var t = (0,useI18n/* useI18n */.Q)("landing-septiembre25").t;
    var videoTitle = t("videos.video-".concat(videoId, ".title"));
    var videoUrl = t("videos.video-".concat(videoId, ".url"));
    var youtubeId = getYouTubeVideoId(videoUrl);
    if (!youtubeId) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTitle, {
                children: videoTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoEmbedContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: "https://www.youtube.com/embed/".concat(youtubeId),
                    title: videoTitle,
                    frameBorder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./services/service.lead.ts
var service_lead = __webpack_require__(67075);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ./utils/errors.ts
var errors = __webpack_require__(31386);
// EXTERNAL MODULE: ../../node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(17473);
;// CONCATENATED MODULE: ./features/magnets/septiembre25/LandingSeptiembre25.tsx









/* import { AccordionItem } from './Accordion'; */ 




var SuscribeSection = function() {
    var t = (0,useI18n/* useI18n */.Q)("landing-septiembre25").t;
    var addErrorToast = (0,useToasts/* useToasts */.e)().addErrorToast;
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), hasSubscribed = ref[0], setHasSuscribed = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), email = ref1[0], setEmail = ref1[1];
    var onSubmit = react.useCallback(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var recaptchaToken, ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!executeRecaptcha) {
                            console.error("Recaptcha not available");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            executeRecaptcha("septiembre25_submit")
                        ];
                    case 1:
                        recaptchaToken = _state.sent();
                        return [
                            4,
                            service_lead/* ServiceLead.create */.W.create({
                                clientName: "unknown",
                                contactEmail: data.email,
                                companyName: "unknown",
                                landingName: "septiembre25",
                                createPipedriveLead: false,
                                isMql: false,
                                isSubscribeToNewsletter: false,
                                recaptchaToken: recaptchaToken
                            })
                        ];
                    case 2:
                        _state.sent();
                        setHasSuscribed(true);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        console.error("[elsindromedeseptiembrePage] Could not send form data. ".concat(ex));
                        addErrorToast(t("subscribe.submit-error", {
                            error: (0,errors/* getErrorMessage */.e)(ex)
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addErrorToast,
        t,
        executeRecaptcha
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Subscribe, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "description",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "landing-septiembre25",
                    i18nKey: "subscribe.desc"
                })
            }),
            hasSubscribed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "landing-septiembre25",
                i18nKey: "subscribe.confirmation"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "emailInput",
                        className: "label",
                        children: t("subscribe.emailLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "input-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "emailInput",
                                className: "input",
                                type: "email",
                                placeholder: t("subscribe.emailPlaceholder"),
                                value: email,
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "button",
                                onClick: function() {
                                    return onSubmit({
                                        email: email
                                    });
                                },
                                disabled: !email,
                                children: t("subscribe.button")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "socials",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text",
                        children: t("subscribe.socials.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "icons",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: t("subscribe.socials.linkedin"),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/septiembre25/linkedIn_logo.png"),
                                    alt: "LinkedIn"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: t("subscribe.socials.x"),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/septiembre25/x_logo.png"),
                                    alt: "X"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var LandingSeptiembre25 = function() {
    var t = (0,useI18n/* useI18n */.Q)("landing-septiembre25").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "logo",
                        src: (0,paths/* getPublicPath */.A)("/images/septiembre25/header.png"),
                        alt: "",
                        role: "presentation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "folder-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "folder",
                                src: (0,paths/* getPublicPath */.A)("/images/septiembre25/folder.png"),
                                alt: "",
                                role: "presentation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tab-1",
                                children: t("folder.tab1")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tab-2",
                                children: t("folder.tab2")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tab-3",
                                children: t("folder.tab3")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "text",
                                src: (0,paths/* getPublicPath */.A)("/images/septiembre25/text-intro-title.png"),
                                alt: "",
                                role: "presentation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "cursor",
                                src: (0,paths/* getPublicPath */.A)("/images/septiembre25/cursor.png"),
                                alt: "",
                                role: "presentation"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuscribeSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "landing-septiembre25",
                            i18nKey: "desc"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/septiembre25/arrow.png"),
                        alt: "",
                        role: "presentation"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cows, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cowsText",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "landing-septiembre25",
                        i18nKey: "cows.desc"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeaturedVideos, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "featuredVideosDesc",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "landing-septiembre25",
                            i18nKey: "videos.desc"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "videos",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedVideo, {
                                videoId: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedVideo, {
                                videoId: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedVideo, {
                                videoId: "3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuscribeSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UfoFooter, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "topText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "landing-septiembre25",
                            i18nKey: "footer.topText"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "beamText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "landing-septiembre25",
                            i18nKey: "footer.beamText"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "logo",
                        src: (0,paths/* getPublicPath */.A)("/images/septiembre25/footer.png"),
                        alt: "Una campa\xf1a de Manfred"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./pages/sindromedeseptiembre.tsx







var MangetsIaPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("landing-septiembre25").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                url: app_urls/* APP_URLS.landingSeptiembre25 */.uu.landingSeptiembre25,
                title: t("page.title"),
                desc: t("page.description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/septiembre25/card_socials.jpg"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingSeptiembre25, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var sindromedeseptiembre = (MangetsIaPage);


/***/ }),

/***/ 67075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ServiceLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3818);
/* harmony import */ var utils_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89608);




/**
 * Service to interact with Manfred public Lead
 */ var ServiceLead = {
    /**
   * Create a new Lead for Manfred
   *
   * @param leadInfo Info to create the new lead
   */ create: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(dealInfo) {
            var url;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                url = (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .getApiPathUrl */ .P)("/v2/public/ui/leads");
                return [
                    2,
                    utils_fetch__WEBPACK_IMPORTED_MODULE_1__/* .post */ .v_("".concat(url), dealInfo)
                ];
            });
        });
        return function(dealInfo) {
            return _ref.apply(this, arguments);
        };
    }()
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48488); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);